<!--
 * @Author: DESKTOP-90MI9K1\admin yangxiong
 * @Date: 2025-02-28 11:53:14
 * @LastEditors: DESKTOP-90MI9K1\admin yangxiong
 * @LastEditTime: 2025-05-12 15:20:23
 * @FilePath: \xypt-vue\src\App.vue
 * @Description: 
 * 
 * Copyright (c) 2025 by 抠脚老汉, All Rights Reserved. 
-->
<template>
  <div id="app">
    <div v-if="!$route.meta.phone">
      <header-view></header-view>
      <div class="min-width">
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <footer-view v-if="!$route.meta.footerHide"></footer-view>
      <login-mask></login-mask>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import HeaderView from './components/header/index.vue'
import FooterView from './components/footer/index.vue'
import LoginMask from './components/loginMask/index.vue'
export default {
  name: 'App',
  components: {
    HeaderView,
    FooterView,
    LoginMask
  },
  created () {
    // if (this.$store.getters.token) {
    this.getRefreshToken()
    // }
  },
  methods: {
    getRefreshToken () {
      // this.$store.dispatch('user/resetToken')
      this.$store.dispatch('user/huiCoreLogin')
    }
  }
}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #202020;
}

.min-width {
  min-width: 1366px;
  min-height: calc(100vh - 370px);
  background-color: #F5F7FA;
  margin-top: 80px;
}

h3 {
  margin: 0;
}

h4 {
  margin: 0;
}

p {
  margin: 0;
}
</style>
